import { SVGProps } from "react";
const MenuIndicator = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={5}
    fill="none"
    viewBox="0 0 59 5"
    {...props}
  >
    <path
      fill="current"
      d="M50.984 4.878c-2.125 0-3.207-.966-4.162-1.819-.862-.77-1.543-1.378-2.998-1.378-1.456 0-2.137.608-3 1.378-.954.853-2.036 1.819-4.161 1.819-2.125 0-3.207-.966-4.162-1.819-.862-.77-1.543-1.378-2.999-1.378-1.455 0-2.136.608-2.998 1.378-.955.853-2.037 1.819-4.162 1.819s-3.207-.966-4.162-1.819c-.861-.77-1.543-1.378-2.998-1.378-1.455 0-2.136.608-2.998 1.378-.955.853-2.037 1.819-4.162 1.819S4.815 3.912 3.86 3.059C2.998 2.29 2.317 1.681.861 1.681A.851.851 0 0 1 0 .84C0 .375.386 0 .861 0c2.125 0 3.207.966 4.162 1.819.863.77 1.544 1.378 3 1.378 1.454 0 2.135-.608 2.998-1.378C11.975.966 13.058 0 15.181 0c2.125 0 3.207.967 4.162 1.82.862.77 1.543 1.377 2.998 1.377 1.455 0 2.136-.608 2.998-1.378C26.295.966 27.378 0 29.502 0c2.125 0 3.207.966 4.162 1.82.862.769 1.544 1.377 2.999 1.377s2.136-.608 2.998-1.378C40.616.966 41.7 0 43.825 0c2.125 0 3.207.966 4.162 1.82.862.769 1.543 1.377 2.998 1.377 1.456 0 2.137-.608 3-1.378C54.938.966 56.02 0 58.145 0c.475 0 .861.376.861.84 0 .465-.386.84-.861.84-1.456 0-2.137.61-3 1.38-.954.852-2.037 1.818-4.162 1.818Z"
    />
  </svg>
);
export default MenuIndicator;
